
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'CartPayment',
  props: {
    action: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters('cart', ['productCart']),
  },
  methods: {
    ...mapActions('cart', ['deleteCart']),
    keepShopping() {
      this.$router.push('/')
    },
    isDeleteProduct(product) {
      this.deleteCart(product)
    },
  },
}
